import {
    IAtualizarProponente,
    IPostProponentes,
    IRemoverProponente,
} from "../../../Interfaces/Vendas/Proponentes/ProponentesInterface";
import {
    AtualizarProponentesVendasService,
    ProponentesGetVendasService,
    ProponentesPostVendasService,
    RemoverProponentesVendasService,
} from "../../../Services/Vendas/Proponentes/ProponentesService";
import { Controller } from "../../Controller";

export async function ProponentesVendasController(idCaso: number) {
    return Controller(ProponentesGetVendasService(idCaso));
}

export async function ProponentesPostVendasController(
    requestBody: IPostProponentes
) {
    return Controller(ProponentesPostVendasService(requestBody));
}

export async function AtualizarProponentesVendasController(
    requestBody: IAtualizarProponente
) {
    return Controller(AtualizarProponentesVendasService(requestBody));
}

export async function RemoverProponentesVendasController(
    requestBody: IRemoverProponente
) {
    return Controller(RemoverProponentesVendasService(requestBody));
}
